module.exports = __webpack_public_path__ + "static/media/history-icon.f17a31e6.svg";